import { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#private-krankenversicherung-und-unterhaltsverpflichtung

    {
        "betragMonatlich": schemaBigDecimal,
        "gehoertZuAntragsteller": "ANTRAGSTELLER_1" | "ANTRAGSTELLER_2"
    }

*/

export const schemaEuropacePrivateKrankenversicherungUndUnterhaltsverpflichtung = z.object({
    betragMonatlich: z.optional(schemaBigDecimal),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(z.nativeEnum(APPLICANT_ATTRIBUTIONS)),
    id: z.string().min(1),
});

export type SchemaEuropacePrivateKrankenversicherungUndUnterhaltsverpflichtung = z.infer<
    typeof schemaEuropacePrivateKrankenversicherungUndUnterhaltsverpflichtung
>;
